export enum Error {
    categoryNotFound = 10001,
    faqInstanceNotFound = 10003,
    itemNotFound = 10005,
    topicNotFound = 10012,
    faqEntityIsNotAvailableInLanguage = 10054,
    needToRefreshToken = 11019,
    accessDenied = 11020,
    thisResourceIsNotAvailableInYourCountry = 16147,
    notEnoughPermissions = 17067,
    communityNotFound = 17068,
    sessionExpired = 17144,
    authorizationInfoIsBroken = 17145,
    accessDeniedToCommunity = 17146,
    yourAccountIsLocked = 17147,
    youDontHaveAccessToAnyCommunity = 17148,
    invalidVerificationCode = 17149,
    yourClientIpAddressDoesNotHaveAccessToThisResource = 17150,
    communityWithNameNotFound = 18082,
    invalidLinkSurveyAlreadyAnswered = 18468,

    linkIsExpired = 20129,

    thisPasswordWasUsed = 25001, // 'You already used this password, please, create a new one.'
    invalidResetPasswordToken = 25002, // 'Token is expired or was already used.'
}
